import { render, staticRenderFns } from "./SdsProductInfo.vue?vue&type=template&id=5da2413e&"
import script from "./SdsProductInfo.vue?vue&type=script&lang=js&"
export * from "./SdsProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports